import actionCreatorFactory from 'typescript-fsa'
import { GetLinkedInFeedRequest } from '@3m5/sm_publish-frontend-api/apis/LinkedInPostApi'
import { GetLinkedInFeedResponse } from '@3m5/sm_publish-frontend-api/models'

const actionCreator = actionCreatorFactory('LINKEDIN_POST')

/*
 * Actions
 */
export const getLinkedInFeedInitiated = actionCreator<GetLinkedInFeedRequest>('GET_LINKED_IN_FEED_FOR_PAGE_INITIATED')
export const getLinkedInFeed = actionCreator.async<GetLinkedInFeedRequest, GetLinkedInFeedResponse>('GET_LINKED_IN_FEED_FOR_PAGE')






 
